module.exports = __webpack_public_path__ + "media/images/locations/ffm-purple-9fdf12ebe81a0f2e7f0c05f244ebaec2.png";